import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import moment from 'moment';
import { forkJoin, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { CaseDetailsService } from 'src/app/features/modules/case-details/case-details.service';
import { CommonService } from 'src/app/services/common.service';
import { BaseCase, DownloadRequestVO } from 'src/app/services/gen';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { TemplateResponse } from 'src/app/services/TemplateMangementWebService';
import {
	LocalTemplateHoverText,
	LookUpDataTypes,
	minimumDate,
	ScrollStrategy,
	StandardTemplateHoverText,
	TEMPLATE_ATTACHMENTS,
	TEMPLATE_CITATION,
} from 'src/app/shared/common-structures/app.constants';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { Utils } from 'src/app/shared/utility/utils';
import { DocumentsService } from '../../documents/documents.service';
import { SharedCodeService } from './../../../../services/shared-code.service';
import { LookupData } from './../../../../services/UserManagement/model/lookupData';
import { SltpCoordinatorRoleCode, TEMPLATE_REQUESTFROM } from './../../../../shared/common-structures/app.constants';
import { DocumentManagementResourceService, HearingCaseVO, HearingSharedCode } from 'src/app/services/HearingWebService';

export const MY_FORMATS = {
	parse: {
		dateInput: 'l',
	},
	display: {
		dateInput: 'l',
		monthYearLabel: 'l',
		dateA11yLabel: 'LLLL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@Component({
	selector: 'app-template-library',
	templateUrl: './template-library.component.html',
	styleUrls: ['./template-library.component.scss'],
	providers: [
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
		},
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
	],
})
export class TemplateLibraryComponent implements OnInit {
	@ViewChild('docuemntTemplateList', { static: true }) docuemntTemplateList: TemplateRef<any>;

	@Input() userSelectedOfficeCode: string;
	@Input() caseDetail: any;
	@Input() readOnlyCharge: boolean;
	@Input() assignedStaffArray: any[] = [];
	@Input() isSystemic = false;
	@Input() isHearing = false;
	@Input() serviceTypeData: HearingSharedCode[] = [];

	stdTemplates: string[] = ['CODCL', 'CODUCL', 'TRANSCASEDOJ', 'TRANSCASEDOJFORNRTS'];
	readOnly: boolean;

	standardText = StandardTemplateHoverText;
	localText = LocalTemplateHoverText;
	filterType = 'All';
	filterTypeOptions: string[] = ['All', 'Standard', 'Local'];
	adHocFields: any = {};
	adHocFieldsList: any[] = [];
	adHocFieldsIndexByField: any = {};
	dropdownTemplatesData: TemplateResponse[] = [];
	hasClosureReason: boolean = false;

	selectedTemplate: any;
	minDate = minimumDate;
	maxDate = new Date();

	citationData: any[] = Utils.strArrayToSharedCodesArray(TEMPLATE_CITATION);
	requestFromData: any[] = Utils.strArrayToSharedCodesArray(TEMPLATE_REQUESTFROM);
	attachmentsData: any[] = Utils.strArrayToSharedCodesArray(TEMPLATE_ATTACHMENTS);
	standardTemplateData: any[] = [];
	localTemplateData: any = [];
	closureReasonData: LookupData[] = [];
	swrTypeData: LookupData[] = [];
	isAdHocFieldsListVisible: boolean;
	public getDescriptionByValue = Utils.getDescriptionByValue;
	noSelection = true;
	orderMap = {
		assignedStaffName: 1,
		assignedStaffPhone: 2,
		assignedStaffTitle: 3,
		eeocContinueInvestigation: 4
	};
	isUploadInProgress = false;

	swrOrderMap = {
		swrType: 1,
		swrOptions: 2,
		intakeReviewTypeA: 3,
		intakeReviewTypeB: 4,
		intakeReviewTypeC: 5,
		intakeReviewTypeD: 6,
		intakeReviewTypeE: 7,
		intakeReviewTypeF: 8,
		intakeReviewTypeG: 9,
		intakeReviewTypeH: 10,
		swrData: 11,
		swrChargeDrafted: 12,
		swrChargeServed: 13,
		swrCreditYear: 14,
		swrDocs: 15,
		sltpCoordinatorName: 16,
		sltpCoordinatorTitle: 17,
		explanation: 18,
		deficiencies: 19

	};
	public dialogRef: MatDialogRef<TemplateLibraryComponent>;
	sltpCoordinatorNameData: LookupData[] = [];
	assignedStaffNameData: LookupData[] = [];
	attachementOptions: any[] = [];
	requestedByOptions: any[] = [];
	swrAdHocItemsOrder = ["swrType", "swrOptions"]
	administrativeClosureSwrOptions = [{ code: "Withdrawal without Benefits", description: "Withdrawal without Benefits" },
	{ code: "Lack of Jurisdiction", description: "Lack of Jurisdiction" },
	{ code: "Unable to Locate Charging Party", description: "Unable to Locate Charging Party" },
	{ code: "Charging Party Failure to Cooperate", description: "Charging Party Failure to Cooperate" },
	{ code: "Failure to Accept Appropriate Relief", description: "Failure to Accept Appropriate Relief" },
	{ code: "Out of Business/Bankruptcy", description: "Out of Business/Bankruptcy" },
	{ code: "Other", description: "Other" }]

	meritClosureSwrOptions = [{ code: "Negotiated Settlement", description: "Negotiated Settlement" },
	{ code: "Withdrawal with Benefits", description: "Withdrawal with Benefits" },
	{ code: "Successful Conciliation", description: "Successful Conciliation" },
	{ code: "Unsuccessful Conciliation", description: "Unsuccessful Conciliation" }];
	substantialWorkReviewSwrOptions = [{ code: "EEOC Asserts Jurisdiction", description: "EEOC Asserts Jurisdiction" },
	{ code: "Right to Sue on Request", description: "Right to Sue on Request" },
	{ code: "Transfers to EEOC after Onset of FEPA Investigation", description: "Transfers to EEOC after Onset of FEPA Investigation" },
	{ code: "Charging Party Sues in Court under the ADEA", description: "Charging Party Sues in Court under the ADEA" }];
	intakeReviewSwrOptions = [{ code: "Yes", description: "Yes" },
	{ code: "No", description: "No" },
	{ code: "N/A", description: "N/A" }];
	swrOptionsData = [];
	showIntakeReviewSection = false;
	intakeReviewTypeAData = [];
	intakeReviewTypeBData = [];
	intakeReviewTypeCData = [];
	intakeReviewTypeDData = [];
	intakeReviewTypeEData = [];
	intakeReviewTypeFData = [];
	intakeReviewTypeGData = [];
	intakeReviewTypeHData = [];
	adHocIntakeReviewFields: any = {};
	adHocIntakeReviewFieldList: any[] = [];
	intakeReviewFieldsRequired = false;
	intakeReviewTypes = [
		'intakeReviewTypeA',
		'intakeReviewTypeB',
		'intakeReviewTypeC',
		'intakeReviewTypeD',
		'intakeReviewTypeE',
		'intakeReviewTypeF',
		'intakeReviewTypeG',
		'intakeReviewTypeH'

	]

	constructor(
		private docServ: DocumentsService,
		private imsLoader: LoadingService,
		public dialog: MatDialog,
		private alrtServ: AlertService,
		private sharedCodeServ: SharedCodeService,
		private cmnServ: CommonService,
		private csDtlsServ: CaseDetailsService,
		private documentManagementResourceService: DocumentManagementResourceService
	) { }

	ngOnInit(): void {
		this.isUploadInProgress = false;
		this.noSelection = true;
		this.swrOptionsData = [];
		if (!this.isSystemic) {
			this.getSharedCode();
			this.getDocumentTemplates();
			this.getChargeClosureReasons();
			this.getSwrTypesList();
			this.getSltpCoordinators();
		}
	}

	getChargeClosureReasons() {
		this.csDtlsServ.getChargeClosureReasons().subscribe(
			(res) => {
				this.closureReasonData = (res || [])
					.filter(x =>
						['DWNRTS', 'OTH'].includes(x.domain) &&
						x.code !== 'DWNRTS_16'
					)
					.sort(Utils.sortSharedCodes);

			},
			(error) => {
				this.alrtServ.error('Error occurred while getting closure reasons.');
			}
		);
	}

	getChargeClosure() {
		this.csDtlsServ.getChargeClosureByFEPA(this.caseDetail?.chargeInquiryId).subscribe(
			(res) => {
				this.isAdHocFieldsListVisible = res;
			},
			(error) => {
				this.alrtServ.error('Error occurred while getting closure.');
			}
		);
	}

	onContactChange(name) {
		let staff = this.assignedStaffArray.find((x) => x.name == name);
		if (staff) {
			this.adHocFields['eeocContactName'] = staff.name;
			this.adHocFields['eeocContactPhone'] = staff.phone;
		}
	}

	label(field) {
		return field[0].toUpperCase() + field.substr(1).replace(/([A-Z])/g, ' $1');
	}

	checkReason(value, field) {
		if (field == 'closureReason') {
			if (value == 'OTH_1') {
				this.adHocFields['otherClosureReason'] = undefined;
			} else {
				delete this.adHocFields['otherClosureReason'];
			}
		}
	}
	getDocumentTemplates() {
		this.imsLoader.show();

		if (this.isHearing) {
			this.docServ.getTemplates('HEARINGS').subscribe({
				next: (res: any) => {
					this.imsLoader.hide();
					this.standardTemplateData = res.filter((x) => x.templateExtension !== 'txt');
					this.localTemplateData = [];
					this.applyFilter();
				},
				error: (error) => {
					this.imsLoader.hide();
					this.alrtServ.error(error?.error);
					this.standardTemplateData = [];
					this.localTemplateData = [];
				}
			});
		} else {
			const requests = [
				this.docServ.getTemplates('PRIVATE').pipe(catchError((err) => of(err))),
				this.docServ.getTemplates('PRIVATE', this.userSelectedOfficeCode).pipe(catchError((err) => of(err))),
			];

			forkJoin(requests).subscribe({
				next: (res: any) => {
					this.imsLoader.hide();
					this.standardTemplateData = res[0] instanceof HttpErrorResponse ? [] : res[0].filter((x) => x.templateExtension !== 'txt');
					this.localTemplateData = res[1] instanceof HttpErrorResponse ? [] : res[1];
					this.applyFilter();
				},
				error: (error) => {
					this.imsLoader.hide();
					this.alrtServ.error(error?.error);
					this.standardTemplateData = [];
					this.localTemplateData = [];
				}
			});
		}
	}

	getData() {
		switch (this.filterType) {
			case 'Standard':
				return [...(this.standardTemplateData || [])];
			case 'Local':
				return [...(this.localTemplateData || [])];
			default:
				return [...(this.standardTemplateData || []), ...(this.localTemplateData || [])];
		}
	}

	applyFilter(filterType?) {
		if (filterType) {
			this.filterType = filterType;
		}
		if (
			typeof this.selectedTemplate == 'string' ||
			this.selectedTemplate == undefined ||
			this.selectedTemplate == null
		) {
			let filteredTemplate = (this.selectedTemplate || '').toLowerCase();
			this.dropdownTemplatesData = this.getData()
				.sort((a, b) => (a.templateName > b.templateName ? 1 : -1))
				.filter((x) => !filteredTemplate || x.templateName?.toLowerCase().includes(filteredTemplate));
		}
	}
	getDropDownData(item) {
		return this[item.field + 'Data'] || [];
	}
	public show(templateCode?: string) {
		this.noSelection = true;
		this.filterType = 'All';
		this.selectedTemplate = undefined;
		this.applyFilter('All');
		//	this.accept = false;
		this.dialogRef = this.dialog.open(this.docuemntTemplateList, {
			width: '950px',
			scrollStrategy: ScrollStrategy,
		});
		this.dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				this.selectedTemplate = null;
			});

		if (templateCode) {
			let selectedTemplate = this.dropdownTemplatesData.find((x) => x.templateCode == templateCode);
			if (selectedTemplate) {
				this.selectedTemplate = selectedTemplate;
				this.onTemplateSelected(this.selectedTemplate);
			}
		}
	}

	/**
	 *
	 * @description we can add custom fields to certain templates
	 */
	processAdhocFields() {
		if (this.selectedTemplate.templateCode === 'FORM257') {
			let date = moment(new Date(this.adHocFields.requestDate)).format('MM/DD/YYYY');
			let data = { ...this.adHocFields, requestFrom: `${this.adHocFields.requestFrom}, dated ${date}` };
			date = moment(new Date(this.adHocFields.issuedOn)).format('MM/DD/YYYY');
			data.attachments = data.attachments
				.map((x) => (x == 'Cause Determination' ? `Cause Determination dated ${date}` : x))
				.join(', ');
			delete data.requestDate;
			delete data.issuedOn;
			return data;
		}
		if (this.selectedTemplate.templateCode === 'SUBWGTRVW' || this.selectedTemplate.templateCode === 'SUBWGTRVWDFT') {
			let data = { ...this.adHocFields };
			if (data.swrType === 'INTAKE REVIEW' || data.swrType === 'SUBSTANTIAL WEIGHT REVIEW: No Cause') {
				if (data.swrOptions === 'N/A') {
					data.swrOptions = "";
				}
			}

			return data;
		}

		return this.adHocFields;
	}

	openTemplate(ext) {
		if (this.isUploadInProgress) {
			return;
		}
		this.isUploadInProgress = true;
		let templateAction = "downloaded";
		this.imsLoader.show();
		let name = this.selectedTemplate.templateName.split('.');
		name.pop();

		if (this.adHocFields?.adoptFEPAClosure === 'null') this.adHocFields.adoptFEPAClosure = null;
		if (this.adHocFields?.eeocContinueInvestigation === 'null') this.adHocFields.eeocContinueInvestigation = null;
		const adhocData = _.cloneDeep(this.processAdhocFields());
		const adhocDataFieldList = _.cloneDeep(this.adHocFieldsList)
		Object.keys(adhocDataFieldList).forEach(key => {
			const fieldKey = adhocDataFieldList[key]
			if (fieldKey.type === 'date') adhocData[fieldKey?.field] = moment(new Date(adhocData[fieldKey?.field])).format('MM/DD/YYYY');
		})
		let payload: DownloadRequestVO = {
			templateCode: this.selectedTemplate.templateCode,
			officeCode: this.selectedTemplate.officeCode,
			resultDocumentType: ext,
			resultFileName: name.join('.'),
			adHocData: adhocData,
		};
		let request;
		if (this.isHearing) {
			request = this.documentManagementResourceService.downloadDocument(this.caseDetail?.hearingCaseId, payload);
		} else if(this.selectedTemplate 
			&& this.selectedTemplate.templateCode 
			&& (this.selectedTemplate.templateCode === 'SUBWGTRVWDFT' || this.selectedTemplate.templateCode === 'SUBWGTRVW')){
			if(payload && payload.resultDocumentType) {
				if(payload.resultDocumentType.toUpperCase() === "DOCX"){
					this.selectedTemplate = this.dropdownTemplatesData.find((x) => x.templateCode === "SUBWGTRVWDFT");
					payload.templateCode = 'SUBWGTRVWDFT';
					request = this.docServ.downloadDocument(this.caseDetail?.chargeInquiryId, payload);
				}else if(payload.resultDocumentType.toUpperCase() === "PDF"){
					templateAction = "uploaded";
					payload.templateCode = 'SUBWGTRVW';
					request = this.docServ.generateAndUploadDocument(this.caseDetail?.chargeInquiryId, payload);
				}else {
					this.alrtServ.error(`Document type is not defined.`);
					this.imsLoader.hide();
					this.isUploadInProgress = false;
					return;
				}
			} else {
				this.alrtServ.error(`Document content and type is not defined.`);
				this.imsLoader.hide();
				this.isUploadInProgress = false;
				return;
			}
				
		}else {		
			request = this.docServ.downloadDocument(this.caseDetail?.chargeInquiryId, payload);
		}
		request.subscribe(
			(res) => {
				this.imsLoader.hide();
				this.isUploadInProgress = false;
				if(this.selectedTemplate 
					&& this.selectedTemplate.templateCode 
					&& !(payload.templateCode === 'SUBWGTRVW' 
					&& templateAction === "uploaded"
					&& payload.resultDocumentType 
					&& payload.resultDocumentType.toUpperCase() === "PDF")){
					let template: TemplateResponse = this.dropdownTemplatesData.find(
						(x) => x.templateCode == this.selectedTemplate.templateCode
					);
					saveAs(res, `${template.templateName}.${ext}`);
					templateAction = "downloaded";
				}
				this.alrtServ.success(`Document has been ${templateAction} successfully.`);
			},
			(error) => {
				this.imsLoader.hide();
				this.isUploadInProgress = false;
				if (error.status === 422) {
					const blobErrorResponse = error?.error;
					var fileReader = new FileReader();

					// This fires after the blob has been read/loaded.
					fileReader.addEventListener('loadend', (e: any) => {
						const fileReaderResponse = e?.srcElement?.result;
						this.alrtServ.error(fileReaderResponse);
					});

					// Start reading the blob as text.
					fileReader.readAsText(blobErrorResponse);

				} else {
					this.alrtServ.error('Error happened while generating document');
				}
			}
		);
	}

	isDisabled() {
		return (
			//	!this.accept ||
			!this.selectedTemplate?.templateCode ||
			(this.getKeys().some((k) => (this.adHocFields[k] == undefined || this.adHocFields[k] === '') &&
				this.getNotRequiredFieldList().includes(k) === false)) ||
			(this.adHocFields.closureReason == 'OTH_1' && !this.adHocFields.otherClosureReason) || this.isUploadInProgress
		);

	}

	getKeys() {
		return this.adHocFieldsList.filter((x) => x.isVisible).map((x) => x.field);
	}

	onTemplateSelected(event) {
		if (this.selectedTemplate?.templateCode === 'PRVCLOSNOT') {
			this.getChargeClosure();
		}
		this.adHocFields = {};
		this.adHocFieldsList = [];
		this.adHocIntakeReviewFieldList = [];
		this.adHocFieldsIndexByField = {};
		this.selectedTemplate.adHocFields = this.selectedTemplate.adHocFields || {};
		let keys = Object.keys(this.selectedTemplate.adHocFields);
		const additionals: any = {
			FORM257: [
				{
					field: 'requestDate',
					display: 'The Notice of Right to Sue was requested on:',
					type: 'date',
					isVisible: true,
					order: 99999,
				},
			],
		};
		const selectTypes = [
			'closureReason',
			'sltpCoordinatorName',
			'swrType',
			'assignedStaffName',
			'citation',
			'requestFrom',
			'attachments',
			'serviceType'
		];

		const areaTypes = [
			'deficiencies',
			'explanation',
			'orderText'
		];
		const maxLengths: any = { 
			agencyHeadName: 40, 
			agencyHeadTitle: 30, 
			orderName: 40,
			orderText: 15000,
			primaryAdjudicatorName: 40,
			primaryAdjudicatorEmail: 80,
			primaryAdjudicatorPhone: 14,
			userName: 40,
			userTitle: 30,
			remarks: 1230,
			deficiencies: 2000,
			explanation: 5000
		};
		const isVisibleMaps = {
			PRVCLOSNOT_eeocContinueInvestigation: false,
			PRVCLOSNOT_adoptFEPAClosure: false,
		};
		this.adHocFieldsList = keys.map((key) => {
			let display = this.selectedTemplate.adHocFields[key];
			let isSelectType = selectTypes.includes(key);
			let isAreaType = areaTypes.includes(key);
			let fieldType = display.toLowerCase().includes('(multi)')
				? 'multi'
				: display.toLowerCase().includes('(intakereview-3opts)')
					? 'intakeReview'
					: display.toLowerCase().includes('(datetime)') || display.toLowerCase().includes('-datetime')
						? 'datetime'
						: display.toLowerCase().includes('(date)') || display.toLowerCase().includes('-date')
							? 'date'
							: display.toLowerCase().includes('(yes/no)')
								? 'radio'
								: isSelectType
									? 'select' :
									isAreaType
										? 'area'
										: 'other';
			// Only set maxLength if explicitly defined for the field
			let maxLength = maxLengths[key];
			return {
				field: key,
				display,
				maxLength: maxLength,
				order: (this.selectedTemplate.templateCode === 'SUBWGTRVW' || this.selectedTemplate.templateCode === 'SUBWGTRVWDFT') ? this.swrOrderMap[key] : this.orderMap[key],
				isVisible: isVisibleMaps[`${this.selectedTemplate.templateCode}_${key}`] ?? true,
				type: fieldType,
			};

		});
		if (additionals[this.selectedTemplate.templateCode]) {
			this.adHocFieldsList.push(...additionals[this.selectedTemplate.templateCode]);
		}
		this.adHocFieldsList.sort((a, b) => ((a.order ? a.order > b.order : a.display > b.display) ? 1 : -1));
		this.adHocFieldsList.forEach((row, i) => {
			this.adHocFieldsIndexByField[row.field] = i;
		});
		let index = this.adHocFieldsList.findIndex((x) => x.field == 'closureReason');
		this.hasClosureReason = index != -1;
		if (this.hasClosureReason) {
			this.adHocFields['otherClosureReason'] = undefined;
		}
		if (this.selectedTemplate?.templateCode == 'CODCL' || this.selectedTemplate?.templateCode == 'CODUCL') {
			this.adHocFields['notaryReq'] = undefined;
		}
		if (this.selectedTemplate.templateCode !== 'RFIRES') {
			keys.forEach((key) => {
				this.adHocFields[key] = undefined;
			});
		}

		if (this.selectedTemplate.templateCode == 'TRANSCASEDOJFORNRTS') {
			let staff = this.assignedStaffArray.find((x) => x.name.includes('Primary'));
			if (staff) {
				this.adHocFields['eeocContactName'] = staff.name;
				this.adHocFields['eeocContactPhone'] = staff.phone;
			} else if (this.assignedStaffArray.length == 1) {
				staff = this.assignedStaffArray[0];
				this.adHocFields['eeocContactName'] = staff.name;
				this.adHocFields['eeocContactPhone'] = staff.phone;
			}
		}
		if (this.selectedTemplate.templateCode == 'SUBWGTRVW' || this.selectedTemplate.templateCode === 'SUBWGTRVWDFT') {
			this.swrTypeData = this.swrTypeData.map((x) => {
				let descr = this.getSWRTypedescription(x.description);
				return { code: descr, description: descr };
			})
			this.adHocFields['swrChargeServed'] = true;
			this.adHocFields['swrCreditYear'] = true;
			this.adHocFields['swrData'] = true;
			this.adHocFields['swrDocs'] = true;
			this.adHocFields['swrChargeDrafted'] = true;
			this.adHocFields['sltpCoordinatorTitle'] = "SLTP Coordinator/Program Manager"
			this.adHocIntakeReviewFieldList = this.adHocFieldsList.filter((x) => this.intakeReviewTypes.includes(x?.field));
			this.adHocFieldsList.splice(-1);
		}
	}

	public radioGroupDisplayLabel(label: string): string {
		return label?.replace('(Yes/No)', '');
	}

	public intakeReviewDisplayLabel(label: string): string {
		return label?.replace('(IntakeReview-3opts)', '');
	}

	public datePickerDisplayLabel(label: string): string {
		return label?.replace('(Date)', '');
	}

	public multiFieldDisplayLabel(label: string): string {
		return label?.replace('(multi)', '');
	}

	displayFn = (item) => {
		if (typeof item === 'string' || item instanceof String) {
			return item;
		}
		if (item) {
			return item.templateName;
		}
	};
	private getSharedCode() {
		this.imsLoader.show();
		const requests = [
			this.sharedCodeServ.getSharedCodes('NRTS_OPTQUAL').pipe(catchError((err) => of(err))),
			this.sharedCodeServ.getSharedCodes('ATTACHMENT_TYPE').pipe(catchError((err) => of(err))),
		];
		forkJoin(requests).subscribe(
			(res) => {
				this.imsLoader.hide();
				this.attachementOptions = res[1] instanceof HttpErrorResponse ? [] : res[1];
				this.requestedByOptions = res[0] instanceof HttpErrorResponse ? [] : res[0];
			},
			(error) => {
				this.imsLoader.hide();
				this.alrtServ.error('Error happened while getting stages and statuses. Please contact help desk.');
				this.attachementOptions = [];
				this.requestedByOptions = [];
			}
		);
	}
	getSwrTypesList() {
		this.sharedCodeServ.getSharedCodes(LookUpDataTypes.FEPA_CREDIT_REQ).subscribe(
			(swrTypesResponse) =>
			(this.swrTypeData = [...swrTypesResponse]
				.filter((item) => ['A', 'O', 'M', 'S', 'I'].includes(item.code))
				.map((x) => {
					return { code: x.description, description: x.description };
				})),
			(error) => this.alrtServ.error('Error while getting swr types. Please contact system administrator.')
		);
	}
	getSWRTypedescription(description) {
		const swrdescriptions = ['administrative closure', 'merit resolution', 'no cause'];
		if (this.selectedTemplate?.templateCode === 'SUBWGTRVW' || this.selectedTemplate?.templateCode === 'SUBWGTRVWDFT') {
			if (swrdescriptions.includes(description.toLowerCase())) {
				description = "SUBSTANTIAL WEIGHT REVIEW: " + description;
			} else if (description.toLowerCase() === 'substantial work') {
				description = "SUBSTANTIAL WORK REVIEW";
			} else if (description.toLowerCase() === 'intake') {
				description = "INTAKE REVIEW";
			}
		}
		return description;

	}
	getSwrTitleList() {

		this.sharedCodeServ.getSharedCodes(LookUpDataTypes.FEPA_CREDIT_REQ).subscribe(
			(swrTypesResponse) =>
			(this.swrTypeData = [...swrTypesResponse]
				.filter((item) => ['A', 'O', 'M', 'S', 'I'].includes(item.code))
				.map((x) => {
					return { code: x.description, description: x.description };
				})),
			(error) => this.alrtServ.error('Error while getting swr types. Please contact system administrator.')
		);
	}
	getSltpCoordinators() {
		const pushedRows = [];
		this.sltpCoordinatorNameData = [];
		this.assignedStaffNameData = [];
		[...(this.cmnServ._getOfficeApprovedUsers() || [])].forEach((row) => {
			this.assignedStaffNameData.push({
				code: `${row.personName.firstName} ${row.personName.lastName}`,
				description: `${row.personName.firstName} ${row.personName.lastName}`,
			});
			this.assignedStaffNameData.sort(Utils.sortSharedCodes);
			Object.keys(row.roleAssignments).forEach((officeId) => {
				// if (officeId !== this.userSelectedOfficeCode || officeId !== 'ALL') return;
				let roles = row.roleAssignments[officeId];
				roles.forEach((role) => {
					if ([SltpCoordinatorRoleCode].includes(role.roleCode)) {
						if (pushedRows.indexOf(row.userDetailId) < 0) {
							pushedRows.push(row.userDetailId);
							this.sltpCoordinatorNameData.push({
								code: `${row.personName.firstName} ${row.personName.lastName}`,
								description: `${row.personName.firstName} ${row.personName.lastName}`,
							});
							this.sltpCoordinatorNameData.sort(Utils.sortSharedCodes);
						}
					}
				});
			});
		});
	}

	onRadioChange(key, value) {
		const mappers = { adeaStatute: 'epaStatute', epaStatute: 'adeaStatute' };
		if (mappers[key]) {
			this.adHocFields[mappers[key]] = !value;
		}
		if (key == 'eeocContinueInvestigation' && this.selectedTemplate.templateCode == 'PRVCLOSNOT') {
			let index = this.adHocFieldsIndexByField['adoptFEPAClosure'];
			if (['DWNRTS_8', 'DWNRTS_9'].includes(this.adHocFields.closureReason) && !value) {
				this.adHocFieldsList[index].isVisible = this.isAdHocFieldsListVisible;
			} else {
				this.adHocFieldsList[index].isVisible = false;
			}
		}
	}
	onSelectChange(key, value, ind) {
		setTimeout(() => {
			this._onSelectChange(key, value, ind);
		}, 50);
	}
	_onSelectChange(key, value, ind) {
		if (key == 'closureReason' && this.selectedTemplate.templateCode == 'PRVCLOSNOT') {
			this.adHocFields['adoptFEPAClosure'] = null;
			this.adHocFields['eeocContinueInvestigation'] = null;
			let index = this.adHocFieldsIndexByField['eeocContinueInvestigation'];
			this.adHocFieldsList[index].isVisible = ['DWNRTS_8', 'DWNRTS_9'].includes(value);
			index = this.adHocFieldsIndexByField['adoptFEPAClosure'];
			if (
				(this.adHocFieldsList[index].isVisible =
					(['DWNRTS_8', 'DWNRTS_9'].includes(value) && !(this.adHocFields.eeocContinueInvestigation ?? true)) ||
					!['DWNRTS_2', 'DWNRTS_8', 'DWNRTS_9'].includes(value))
			) {
				this.adHocFieldsList[index].isVisible = this.isAdHocFieldsListVisible;
			} else {
				this.adHocFieldsList[index].isVisible = false;
			}
		}
		if (key == 'attachments' && this.selectedTemplate.templateCode == 'FORM257') {
			let index = this.adHocFieldsList.findIndex((x) => x.field == 'issuedOn');
			if (value.includes('Cause Determination')) {
				if (index < 0) {
					this.adHocFieldsList.splice(ind + 1, 0, {
						type: 'date',
						field: 'issuedOn',
						display: 'Cause Determination Issue On:',
						isVisible: true,
						order: 9999,
					});
				}
			}
		}

		if (this.selectedTemplate.templateCode == 'SUBWGTRVW' || this.selectedTemplate.templateCode == 'SUBWGTRVWDFT') {

			if (key == 'swrType') {
				this.swrOptionsData = [];
				this.adHocFields['swrOptions'] = "";
				this.clearIntakeReviewFields();
				this.noSelection = true;
				if (value === 'SUBSTANTIAL WEIGHT REVIEW: Administrative Closure') {
					this.showIntakeReviewSection = false;
					this.noSelection = false;
					this.swrOptionsData = [...this.administrativeClosureSwrOptions];
					this.adHocFields['swrTitle'] = "Administrative Closure: Indicate in narrative form, documents, efforts made etc., delineate and outcomes.";
				}
				if (value === 'SUBSTANTIAL WEIGHT REVIEW: Merit Resolution') {
					this.showIntakeReviewSection = false;
					this.noSelection = false;
					this.swrOptionsData = [...this.meritClosureSwrOptions];
					this.adHocFields['swrTitle'] = "MERIT RESOLUTION: Indicate in narrative form, issues, documents, interviews, etc., delineate those accepted, evidence secured and outcomes.";
				}
				if (value === 'SUBSTANTIAL WORK REVIEW') {
					this.showIntakeReviewSection = false;
					this.noSelection = false;
					this.swrOptionsData = [...this.substantialWorkReviewSwrOptions];
					this.adHocFields['swrTitle'] = "SUBSTANTIAL WORK CREDIT:  Indicate in narrative form: information and documents in the file. Delineate how Substantial Work Credit was or was not established.";
				}

				if (value === 'SUBSTANTIAL WEIGHT REVIEW: No Cause') {
					this.showIntakeReviewSection = false;
					this.noSelection = true;
					this.swrOptionsData = [];
					this.adHocFields['swrOptions'] = "N/A";
					this.adHocFields['swrTitle'] = "NO CAUSE REVIEW:  Indicate in narrative form, issues, documents, interviews, etc., delineate those accepted, evidence secured and outcomes.";
				}

				if (value === 'INTAKE REVIEW') {
					this.noSelection = true;
					this.showIntakeReviewSection = true;
					this.swrOptionsData = [];
					this.adHocFields['swrOptions'] = "N/A";
					this.adHocFields['swrTitle'] = "INTAKE CREDIT:  Verify the following:";
				}

			}
			if (key == 'swrOptions') {
				if (value.length === 0) {
					value = "";
				}
				this.adHocFields['swrOptions'] = value;

			}
			if (key.startsWith('intakeReviewType')) {
				this.adHocFields[key] = this.getIntakeReviewDisplayValue(key) + " " + value;

			}

		}
	}

	clearIntakeReviewFields() {
		let keys = Object.keys(this.selectedTemplate.adHocFields);
		keys.forEach((key) => {
			if (this.intakeReviewTypes.includes(key)) {
				this.adHocFields[key] = "";
				this.adHocFieldsList[key] = undefined;
			}
		});
	}
	getIntakeReviewDisplayValue(fieldName) {
		let fieldDisplayName = "";
		const selectedFields = this.adHocFieldsList.filter((x) => x?.field === fieldName);
		if (selectedFields && selectedFields.length > 0 && selectedFields[0]?.display) {
			fieldDisplayName = this.intakeReviewDisplayLabel(selectedFields[0]?.display);

		}
		return fieldDisplayName;
	}

	getNotRequiredFieldList() {
		let notRequiredFieldList: string[] = [];
		if (this.selectedTemplate.templateCode === 'SUBWGTRVW' || this.selectedTemplate.templateCode === 'SUBWGTRVWDFT') {
			if (this.adHocFields.swrType !== "INTAKE REVIEW") {
				notRequiredFieldList = [...this.intakeReviewTypes]
			}
		}
		return notRequiredFieldList;
	}


}
